import { render, staticRenderFns } from "./ModalMove.vue?vue&type=template&id=52fdc625&scoped=true"
import script from "./ModalMove.vue?vue&type=script&lang=js"
export * from "./ModalMove.vue?vue&type=script&lang=js"
import style0 from "./ModalMove.vue?vue&type=style&index=0&id=52fdc625&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fdc625",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52fdc625')) {
      api.createRecord('52fdc625', component.options)
    } else {
      api.reload('52fdc625', component.options)
    }
    module.hot.accept("./ModalMove.vue?vue&type=template&id=52fdc625&scoped=true", function () {
      api.rerender('52fdc625', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalMove.vue"
export default component.exports